module.exports = __webpack_public_path__ + "04_bob_yellow.b6496099.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/04_bob_yellow.png
// module id = wDey
// module chunks = 0